import * as React from 'react';
import { CustomButton, ButtonType, ModalBody, Modal, ModalSize, ModalFooter, CustomSubmitButton } from "soprasteria-ui-library";
import { useAuth } from '../../../../App';
import { OrthodonticReferralAdministrationApi } from "../../../../api/OrthodonticReferralAdministrationApi";
import { IOrthodonticReferral } from '../../../../models/IOrthodonticReferral';
import { ORTHODONTIC_REFERRAL, PATIENT } from '../../../../utils/RouteConstants';
import { useHistory } from 'react-router-dom';

interface IOrthodonticReferralCopyButton {
    orthodonticReferralId: number;
    onSuccess: (copiedData: IOrthodonticReferral, message: string) => void;
    changeErrorMessage: (message: string) => void;
    patientGuid: string;
}

export const OrthodonticReferralCopyButton: React.FunctionComponent<IOrthodonticReferralCopyButton> = ({ onSuccess, changeErrorMessage, orthodonticReferralId, patientGuid }) => {
    const auth = useAuth();
    const api = new OrthodonticReferralAdministrationApi(auth);
    const [isCopying, setIsCopying] = React.useState<boolean>(false);
    const history = useHistory();

    const copyOrthodonticReferral = () => {
        setIsCopying(true);
        api.copyOrthodonticReferral(orthodonticReferralId,
            (copiedData: IOrthodonticReferral) => {
                document.getElementById("close-copy-orthodontic-referral-modal")?.click();
                history.replace(`/${PATIENT}/${patientGuid}/${ORTHODONTIC_REFERRAL}`, copiedData);
                onSuccess(copiedData, "Ortodontiremissen har kopierats");
            },
            (error) => {
                changeErrorMessage(error);
            },
            () => {
                setIsCopying(false);
            })
    }

    return (
        <>
            <CustomButton buttonType={ButtonType.success} buttonText="Kopiera till ny ortodontiremiss" data-toggle="modal" data-target="#copy-orthodontic-referral-modal" />
            <Modal header="Kopiera till ny ortodontiremiss" id="copy-orthodontic-referral-modal" modalSize={ModalSize.normal}>
                <ModalBody>
                    <p>Är du säker på att du vill skapa upp en ny ortodontiremiss utifrån den aktuella remissen?</p>
                </ModalBody>
                <ModalFooter>
                    <CustomButton buttonType={ButtonType.general} buttonText="Nej" data-dismiss="modal" id="close-copy-orthodontic-referral-modal" />
                    <CustomSubmitButton onButtonSubmit={copyOrthodonticReferral} isLoading={isCopying}>Ja</CustomSubmitButton>
                </ModalFooter>
            </Modal>
        </>
    )
}